import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMomentumStrongPositive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.7892 12.4154C23.7892 11.6487 24.379 11 25.2047 11H35.5846C36.3513 11 37 11.6487 37 12.4154V22.7953C37 23.621 36.3513 24.2108 35.5846 24.2108C34.7589 24.2108 34.1691 23.621 34.1691 22.7953V15.8361L22.9046 27.1006C22.3148 27.6904 21.4302 27.6904 20.8994 27.1006L14.353 20.5542L5.44753 29.4597C4.85776 30.0494 3.97311 30.0494 3.44232 29.4597C2.85256 28.9289 2.85256 28.0442 3.44232 27.5134L13.3504 17.5464C13.8812 17.0156 14.7658 17.0156 15.2966 17.5464L21.843 24.0928L32.1639 13.8309H25.2047C24.379 13.8309 23.7892 13.2411 23.7892 12.4154Z" })
});
export default SvgMomentumStrongPositive;
